
import { GlobalContext } from 'components/GlobalContext';
import { IContactInitResult } from 'models/sql/IContact';
import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Form, Modal, Nav, Navbar } from 'react-bootstrap';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ContactService from 'services/ContactService';
import ContactsDetail from './Detail';
import ContactsLookup from './Lookup';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import './styles/Contacts.scss';

const ContactsIndex = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const navigate = useNavigate();
    const [showLookup, setShowLookup] = useState(false);
    const [id, setid] = useState<string>();
    const [baseData, setbaseData] = useState<IContactInitResult>();

    useEffect(() => {
        globalContext.setSecondaryNav(<>
            <Navbar.Brand
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}><strong><FontAwesomeIcon icon={faChevronLeft as IconProp} />&nbsp;Contact Information</strong></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <Nav.Link onClick={() => showLookupModal()}>Lookup</Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </>);

        (async () => {
            globalContextRef.current.setLoading(true);
            const accessToken = await globalContext.getAccessTokenAsync();
            const result = await ContactService.GetInitAsync(accessToken);

            if (result) {
                setbaseData(result);
            }

            globalContextRef.current.setLoading(false);
        })();
    }, []);

    const showLookupModal = () => {
        setShowLookup(true);
        window.setTimeout(
            () => {
                (document.querySelectorAll("#lookupModal input")[0] as HTMLElement).focus();
            },
            20);
    };

    const hideLookupModal = () => {
        setShowLookup(false);
    }

    const lookupTemplateDataAsync = async () => {
        hideLookupModal();

        if (id) {
            globalContext.setLoading(true);
            const accessToken = await globalContext.getAccessTokenAsync();
            const contact = await ContactService.GetAsync(accessToken, parseInt(id));

            if (contact.record) {
                navigate(`/Contacts/Detail/${contact.record?.contactId}`)
            }
            else {
                globalContext.showErrorMessage(`Couldn't find Contact with id ${id}`, 10000);
            }

            globalContext.setLoading(false);
        }
    }

    if (!baseData) {
        return (
            <>
            </>
        );
    }

    return (
        <>
            <div>
                <Routes>
                    <Route path={"/Detail/:id?"} element={<ContactsDetail baseData={baseData} />} />
                    <Route path={"/:page"} element={<ContactsLookup baseData={baseData} />} />
                    <Route path={"*"} element={<ContactsLookup baseData={baseData} />} />
                </Routes>
            </div>

            <Modal show={showLookup} id="lookupModal" onHide={hideLookupModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Lookup Contact by Id</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="id">
                            <Form.Control
                                type="text"
                                placeholder="Contact Id"
                                value={id}
                                onChange={(e) => setid(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        lookupTemplateDataAsync();
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideLookupModal}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={lookupTemplateDataAsync}>
                        Find Contact
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ContactsIndex;
